/*
 * @Author: yuanweijiang
 * @Date: 2025-12-16 14:40:26
 * @LastEditors: yuanweijiang
 */
//埋点接口封装
import { getUserTool } from '@/api/skyline'
import store from '@/store/index.js'

class TrackingService {
    // 防抖定时器
    static debounceTimer = null
    // 记录工具使用
    static trackToolUsage(useDebounce = false, delay = 300) {
        const indexName = store.state.checkIndex
        const checkTabList = store.state.checkTabList
        const id = checkTabList.filter((item) => {
            return item.displayName === indexName
        })[0]?.id
        // 如果启用防抖
        if (useDebounce) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer)
            }

            // 设置新的防抖定时器
            this.debounceTimer = setTimeout(() => {
                getUserTool({ id })
                // 执行完成后清除定时器引用
                this.debounceTimer = null
            }, delay)
        } else {
            // 不使用防抖，直接执行
            getUserTool({ id })
        }
    }
}

export default TrackingService
